export const unionConfig = {
    headings: [
        {
            headingLabel: "Active",
            width: "10%",
            inputType: "checkbox"
        },
        {
            headingLabel: "Union",
            width: "80%",
            inputType: "text"
        },
        {
            headingLabel: "",
            width: "10%",
            inputType: "text"
        },

    ],
    dataNodes: ["is_active", "name"],
    primaryKey: "id",
    nodeFields: [
        {
            column: "is_active",
            icon: "check"
        },
    ],
    actions: ["pen"],
    inlineEdits: [
        {
            dataNode: "is_active",
            width: "10%"
        },
        {
            dataNode: "name",
            width: "85%"
        }
    ],
}